{
  "name": "editor-web",
  "version": "2.20.10",
  "license": "MIT",
  "main": "node_modules/expo/AppEntry.js",
  "scripts": {
    "prettier:write": "prettier --write .",
    "prettier:check": "prettier --check .",
    "lint:write": "eslint App.tsx ./src/**/*.{ts,tsx} --fix",
    "lint:check": "eslint App.tsx ./src/**/*.{ts,tsx}",
    "start": "./scripts/start-dev.sh",
    "android": "DARK_MODE=media expo start --android --clear",
    "ios": "DARK_MODE=media expo start --ios --clear",
    "web": "DARK_MODE=media ./scripts/start-dev.sh",
    "web:staging": "EXPO_PUBLIC_ENV=STAGE DARK_MODE=media ./scripts/start-dev.sh",
    "bundle:web": "expo export --source-maps --platform web --clear",
    "sentry:upload-sourcemaps": "node scripts/expo-upload-sourcemaps.js dist",
    "serve:web": "npx server dist",
    "test": "jest",
    "e2e": "playwright test",
    "e2e:ui": "playwright test --ui",
    "typecheck:e2e": "tsc -p e2e",
    "analyze:web": "yarn bundle:web && source-map-explorer --no-border-checks 'dist/_expo/static/js/web/*.js' 'dist/_expo/static/js/web/*.js.map'",
    "analyze:ios": "source-map-explorer 'dist/_expo/static/js/ios/*.js' 'dist/_expo/static/js/ios/*.js.map'",
    "analyze:android": "source-map-explorer 'dist/_expo/static/js/android/*.js' 'dist/_expo/static/js/android/*.js.map'",
    "datadog-ci": "datadog-ci",
    "sentry-cli": "sentry-cli",
    "prepare": "husky",
    "postinstall": "node scripts/copy-sdk-files.js",
    "install-local-sdk": "./scripts/install-local-sdk.sh",
    "update-sdk": "./scripts/update-sdk.sh",
    "setup-gitflow": "./scripts/setup-gitflow.sh",
    "make-release": "./scripts/release.sh",
    "release": "yarn run setup-gitflow && yarn run make-release"
  },
  "dependencies": {
    "@amplitude/analytics-react-native": "^1.4.9",
    "@amplitude/experiment-react-native-client": "^1.8.0",
    "@amplitude/plugin-session-replay-browser": "^1.13.4",
    "@datadog/browser-rum": "^5.35.1",
    "@datadog/mobile-react-native": "^2.6.2",
    "@datadog/mobile-react-navigation": "^2.6.2",
    "@didomi/react": "^1.8.6",
    "@expo/html-elements": "^0.10.1",
    "@expo/metro-runtime": "~6.1.2",
    "@gorhom/bottom-sheet": "^5",
    "@lottiefiles/dotlottie-react": "^0.12.3",
    "@n8n/chat": "^0.50.0",
    "@photosi/auth": "14.0.0",
    "@photosi/braze-service": "1.18.0",
    "@photosi/expo-photosi-sdk": "0.2.534",
    "@photosi/gtm-service": "^2.0.0",
    "@photosi/web-design-system": "5.5.0",
    "@react-native-async-storage/async-storage": "^2.2.0",
    "@react-native-clipboard/clipboard": "^1.16.3",
    "@react-navigation/elements": "^2.4.2",
    "@react-navigation/native": "^7.1.9",
    "@react-navigation/native-stack": "^7.3.13",
    "@sentry/browser": "^9.10.1",
    "@sentry/react-native": "^7.8.0",
    "@sentry/wasm": "^9.10.1",
    "@storybook/addon-ondevice-actions": "^10.7.1",
    "@storybook/addon-ondevice-controls": "^10.7.1",
    "@storybook/react-native": "^10.7.1",
    "expo": "^54.0.31",
    "expo-datadog": "^51.0.2",
    "expo-font": "~14.0.10",
    "expo-haptics": "~15.0.8",
    "expo-image": "~3.0.11",
    "expo-image-picker": "~17.0.10",
    "expo-linear-gradient": "~15.0.8",
    "expo-linking": "~8.0.11",
    "expo-localization": "~17.0.8",
    "expo-screen-orientation": "~9.0.8",
    "i18next": "^23.10.1",
    "jest-expo": "~54.0.16",
    "js-cookie": "^3.0.7",
    "jwt-decode": "^4.0.0",
    "lottie-react-native": "~7.3.1",
    "mobx": "^6.13.5",
    "mobx-react-lite": "^4.0.7",
    "mobx-state-tree": "^6.0.1",
    "react": "19.1.0",
    "react-dom": "19.1.0",
    "react-native": "0.81.5",
    "react-native-dotenv": "^3.4.11",
    "react-native-gesture-handler": "~2.28.0",
    "react-native-qrcode-svg": "^6.3.20",
    "react-native-reanimated": "~4.1.1",
    "react-native-safe-area-context": "~5.6.0",
    "react-native-screens": "~4.16.0",
    "react-native-svg": "15.12.1",
    "react-native-video": "^6.11.0",
    "react-native-web": "^0.21.0",
    "react-native-worklets": "0.5.1",
    "storybook": "^10.6.5"
  },
  "devDependencies": {
    "@babel/core": "^7.29.6",
    "@changesets/cli": "^2.29.5",
    "@commitlint/cli": "^21.0.1",
    "@commitlint/config-conventional": "^21.0.1",
    "@datadog/datadog-ci": "^2.41.0",
    "@playwright/test": "1.64.0",
    "@testing-library/react-native": "^12.8.1",
    "@types/jest": "^29.5.13",
    "@types/js-cookie": "^3.0.6",
    "@types/react": "~19.1.10",
    "@typescript-eslint/eslint-plugin": "^6.21.0",
    "@typescript-eslint/parser": "^6.21.0",
    "babel-plugin-module-resolver": "^5.0.2",
    "eslint": "^9.26.0",
    "eslint-config-prettier": "9.1.0",
    "eslint-config-standard": "17.1.0",
    "eslint-plugin-import": "2.29.1",
    "eslint-plugin-n": "^17.7.0",
    "eslint-plugin-promise": "6.1.1",
    "eslint-plugin-react": "7.34.1",
    "eslint-plugin-react-native": "4.1.0",
    "eslint-plugin-testing-library": "^6.5.0",
    "husky": "^9.1.6",
    "jest": "^29.7.0",
    "mobx-devtools-mst": "^0.9.46",
    "prettier": "^3.3.3",
    "source-map-explorer": "^2.5.3",
    "typescript": "~5.9.2"
  },
  "private": true,
  "engines": {
    "node": ">=24.12.0"
  },
  "overrides": {
    "react": "19.1.0",
    "react-dom": "19.1.0",
    "@amplitude/analytics-core": "2.35.0"
  },
  "packageManager": "yarn@1.22.22+sha512.a6b2f7906b721bba3d67d4aff083df04dad64c399707841b7acf00f6b133b7ac24255f2652fa22ae3534329dc6180534e98d17432037ff6fd140556e2bb3137e"
}
